import * as types from "../actions/ActionTypes";
import initialState from "./initialState";
import {CLOSE_SNACKBAR, INSERT_SNACKBAR, REMOVE_SNACKBAR} from "../actions/NotificationActions";

export default (state = initialState.notifications, action) => {
    switch (action.type) {
        case CLOSE_SNACKBAR:
            return state.map(notification => (
                (action.dismissAll || notification.key === action.key)
                    ? {...notification, dismissed: true}
                    : {...notification}
            ));
        case REMOVE_SNACKBAR:
            return state.filter(
                notification => notification.key !== action.key,
            );
        case INSERT_SNACKBAR: {
            const {data} = action.payload;
            return [
                ...state,
                {
                    key: action.key,
                    ...data,
                },
            ];
        }
        default:
            return state;
    }
};
